<template>
	<div class="SupportPhotosPage">
		<header>
			<img src="/map/dist/skin/logo.svg" alt="Logo"/>
			<span v-if="isLoading" class="loading-indicator">
			<LoadingIndicator style="height: 16px;"/>
			Bezig met laden...
			</span>
		</header>
		<div class="uploaded-images">
			<img class="uploaded-image" v-for="file in files" :src="'/files/getById?height=600&width=600&file_id=' + file.id" :alt="file.file_name"/>
		</div>
		<div class="upload-container">
			<h2>Bestanden uploaden</h2>
			<div class="upload-field"  @click="$refs.uploadInput.click()"  @dragover="$event.preventDefault()" @dragleave="dragFocus =
    false" @dragenter="dragFocus = true" @drop="onDrop($event)" :class="{hover: dragFocus}">
				<input type="file" id="file" ref="uploadInput" multiple accept="image/*" @change="uploadFiles($event.target.files)" />
				<UploadIcon size="3x"/>
				<p>Klik hier of sleep de afbeeldingen in dit vak</p>
			</div>
		</div>
	</div>
</template>

<script>
import {QueuedFile} from "@/common/queued-file";
import LoadingIndicator from "@/components/LoadingIndicator.vue";
import {client} from "@/store";
import UploadIcon from "vue-feather-icons/icons/UploadIcon";
import {mapActions, mapState} from "vuex";

export default {
	name: "SupportPhotos",
	components: {
		LoadingIndicator,
		UploadIcon},
	data() {
		return {
			token: this.$route.params.token,
			tokenModel: null,
			dragFocus: false,
			files: [],
		};
	},
	mounted() {
		this.fetchActionToken();
	},
	computed: {
		...mapState({
			isLoading: "loading"
		}),
	},
	methods: {
		...mapActions({
			setLoading: "map/setLoading",
			setIdle: "map/setIdle"
		}),

		async uploadFiles(files) {
			this.setLoading();
			const queuedFiles = [];
			for (const file of files) {
				queuedFiles.push(new QueuedFile(file, "support/support", this.tokenModel.token_data.companyId, this.$forceUpdate));
			}
			await Promise.all(queuedFiles.map(file => file.upload()));
			this.$refs.uploadInput.value = "";
			this.getFiles(this.tokenModel.token_data.companyId, this.tokenModel.token);
		},
		onDrop(event) {
			event.preventDefault();
			this.dragFocus = false;
			this.uploadFiles(event.dataTransfer.files);
		},
		fetchActionToken() {
			this.setLoading();
			client.query(`query($token: String!) {
				customerActionToken(token: $token) {
					token
					token_data
				}
			}`, {
				token: this.token,
			}).then(result => {
				this.tokenModel = result.customerActionToken;
				this.tokenModel.token_data = JSON.parse(this.tokenModel.token_data);
				this.getFiles(this.tokenModel.token_data.companyId, this.tokenModel.token);

			}).catch(error => {
				this.setIdle();
				this.$notify({
					group: "app",
					title: "Er is iets misgegaan",
					type: "error",
					text: `Probeer het later nog eens.`
				});
			});
		},
		getFiles(companyId, token) {
			client.query(`query($types: [String]!, $company_id: ID!, $token: String!) {
				getCustomerFiles(types: $types, company_id: $company_id, token: $token) {
					id
					company_id
					file_name
					type
					upload_date
					size
				}
			}`, {
				company_id: companyId,
				types: [
					"support/afgebroken", "support/support"
				],
				token: token,
			}).then(result => {
				this.files = result.getCustomerFiles;
				this.setIdle();
			}).catch(error => {
				this.setIdle()
				this.$notify({
					group: "app",
					title: "Fout bij het ophalen van bestanden",
					type: "error",
					text: `bestanden konden niet opgehaald worden.`
				});
			});
		},
	},
};
</script>

<style scoped lang="scss">
.SupportPhotosPage {
	overflow: auto;
	height: 100%;
}

header {
	margin: 24px;
	display: flex;
	align-items: center;

	.loading-indicator {
		color: rgb(119, 119, 119);
		margin-left: auto;
		margin-right: auto;
		padding-right: 230px;
	}
}
.uploaded-images {
	margin: 24px;
	display: flex;
	flex-wrap: wrap;
	flex-direction: row;
	gap: 16px;

	.uploaded-image {
		height: 150px;
	}
}
.upload-container {
	margin: 24px;

	input {
		display: none;
	}

	.upload-field {
		background-color: #f2f5f7;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		padding: 24px;
		min-height: 200px;
		border-radius: 4px;
		border: 1px solid #cad5dd;

		&.hover {
			border: 2px solid #35a5a4;
			color: #35a5a4;
			background-color: #8dd7cf;
		}

		* {
			pointer-events: none;
		}
	}
}
</style>
